import { RegionService } from './../services/region.service';
import { RestAddressApi } from './rest-address.api';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CityService, CountryService, DiagnoseService } from '../services';
import { AddressApi, ManualApi } from '../base';
import { RestManualApi } from './rest-manual.api';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    CountryService,
    RegionService,
    CityService,
    DiagnoseService,
    { provide: AddressApi, useClass: RestAddressApi },
    { provide: ManualApi, useClass: RestManualApi }
  ]
})
export class RestApiModule { }
